export const occupancyPieOwnerVsPaidReserv =
  "This is the percentage of nights that have been occupied by guests and owners out of the total booked nights. This number is calculated by taking the Number of Nights Sold and adding the Number of Owner Nights Booked and dividing it by the Total Number of Nights";

